export default {
  methods: {
    getOrgObjectDropdownItems(data) {
      let items = []

      if (!data || !data.hasOwnProperty('status')) {
        return items;
      }

      if (data.status == "draft") {
        items = [
          {
            name: 'Activate',
            value: 'activate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Rename',
            value: 'rename_action',
            icon: 'icons/dropdown/rename.svg',
            order: 2
          },
          {
            name: 'Delete',
            value: 'delete_action',
            icon: 'icons/dropdown/delete.svg',
            negative: true,
            order: 3,
          },
        ]
        
        // Add Clone option only if name length is <= 111 characters
        if (data?.name && data.name.length <= 111) {
          items.push({
            name: 'Clone',
            value: 'cloned_action',
            icon: 'icons/dropdown/clone.png',
            order: 4,
          });
        }
      } else if (data.status === "active") {
        if (data.assigned_employees && data.assigned_employees.length === 0) {
          items = [
            {
              name: 'Retire',
              value: 'retire_action',
              icon: 'icons/dropdown/activate.svg',
              order: 1
            },
            // hide for ticket ER-3750
            // {
            //   name: 'De-Activate',
            //   value: 'deactivate_action',
            //   icon: 'icons/dropdown/activate.svg',
            //   order: 2
            // },
            ...items
          ];
        }

        items = [
          ...items,
          {
            name: 'Attach Role',
            value: 'attach_position_role',
            icon: 'icons/dropdown/attach.svg',
            order: 3
          },
          {
            name: 'Rename',
            value: 'rename_action',
            icon: 'icons/dropdown/rename.svg',
            order: 4
          }
        ];
        
        // Add Clone option only if name length is <= 111 characters
        if (data?.name && data.name.length <= 111) {
          items.push({
            name: 'Clone',
            value: 'cloned_action',
            icon: 'icons/dropdown/clone.png',
            order: 5
          });
        }
      } else if (data.status == "inactive") {
        items = [
          {
            name: 'Re-Activate',
            value: 'reactivate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Rename',
            value: 'rename_action',
            icon: 'icons/dropdown/rename.svg',
            order: 2
          },
        ]
        
        // Add Clone option only if name length is <= 111 characters
        if (data?.name && data.name.length <= 111) {
          items.push({
            name: 'Clone',
            value: 'cloned_action',
            icon: 'icons/dropdown/clone.png',
            order: 3,
          });
        }
      } else if (data.status == "retired") {
        if(data.archived === true) {
          items =[
            {
              name: 'Unarchive',
              value: 'unarchive_action',
              icon: 'icons/dropdown/unarchive.svg',
              order: 4
            },
          ]
        }
        else {
          items = [
            {
              name: 'Re-Activate',
              value: 'reactivate_action',
              icon: 'icons/dropdown/activate.svg',
              order: 1
            },
            {
              name: 'Rename',
              value: 'rename_action',
              icon: 'icons/dropdown/rename.svg',
              order: 2
            },
          ]
          
          // Add Clone option only if name length is <= 111 characters
          if (data?.name && data.name.length <= 111) {
            items.push({
              name: 'Clone',
              value: 'cloned_action',
              icon: 'icons/dropdown/clone.png',
              order: 3,
            });
          }
          
          items.push({
            name: 'Archive',
            value: 'archive_action',
            icon: 'icons/dropdown/archive.svg',
            order: 4
          });
        }
      } else if (typeof data.status === "string" && data.status.toLowerCase() === "archived") {
        // Archived positions surfaced as status === "archived" (the
        // status === "retired" + archived: true variant is handled above).
        // Without this branch the menu would open empty, making the
        // three-dot icon look like it does not open at all.
        items = [
          {
            name: 'Unarchive',
            value: 'unarchive_action',
            icon: 'icons/dropdown/unarchive.svg',
            order: 1
          },
        ];
      }
      return items;
    },
    getEmployeeDropdownItems(data) {      
      if (data.status) {
        data.current_status = data.status; // Map status to current_status
      }
      let items = []
      if (data.current_status == "draft") {
        items = [
          {
            name: 'Activate',
            value: 'activate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Delete',
            value: 'delete_action',
            icon: 'icons/dropdown/delete.svg',
            negative: true,
            order: 2,
          },
          {
            name: 'Rename',
            value: 'edit_action',
            icon: 'icons/dropdown/rename.svg',
            order: 3
          },
          {
            name: 'Change Picture',
            value: 'change_picture_action',
            icon: 'icons/dropdown/change_picture.svg',
            order: 4,
          },
        ]
      } else if (data.current_status == "active") {
        let giveAccessItem = {
          name: 'Give Access',
          value: 'give_access_action',
          icon: 'icons/dropdown/give_access.svg',
          order: 1
        }
        let suspendAccessItem = {
          name: 'Suspend Access',
          value: 'suspend_access_action',
          icon: 'icons/dropdown/suspend_access.svg',
          order: 2,
          negative: true
        }
        let giveBackAccessItem = {
          name: 'Give Back Access',
          value: 'give_back_access_action',
          icon: 'icons/dropdown/give_access.svg',
          order: 3
        }
        items = [
          {
            name: 'Terminate',
            value: 'terminate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Rename',
            value: 'edit_action',
            icon: 'icons/dropdown/rename.svg',
            order: 2
          },
          {
            name: 'Change Picture',
            value: 'change_picture_action',
            icon: 'icons/dropdown/change_picture.svg',
            order: 3,
          },
          // Show access-related items only if not owner
          ...(data.access?.is_suspended
            ? [giveBackAccessItem]
            : data.access?.has_access && !data.access?.is_owner
            ? [suspendAccessItem]
            : !data.access?.is_owner
            ? [giveAccessItem]
            : []),
        ]
      } else if (data.current_status == "terminated") {
        if(data.archived === true) {
          items =[
            {
              name: 'Rename',
              value: 'edit_action',
              icon: 'icons/dropdown/rename.svg',
              order: 1
            },
            {
              name: 'Change Picture',
              value: 'change_picture_action',
              icon: 'icons/dropdown/change_picture.svg',
              order: 2
            },
            {
              name: 'Unarchive',
              value: 'unarchive_action',
              icon: 'icons/dropdown/unarchive.svg',
              order: 3
            },
          ]
        }
        else { 
          items = [
            {
              name: 'Re-Activate',
              value: 'reactivate_action',
              icon: 'icons/dropdown/activate.svg',
              order: 1
            },
            {
              name: 'Rename',
              value: 'edit_action',
              icon: 'icons/dropdown/rename.svg',
              order: 3
            },
            {
              name: 'Change Picture',
              value: 'change_picture_action',
              icon: 'icons/dropdown/change_picture.svg',
              order: 4
            },
            {
              name: 'Archive',
              value: 'archive_action',
              icon: 'icons/dropdown/archive.svg',
              order: 5
            },
          ]
        }
      }
      return items;
    },
    getReadinessEmployeeDropdownItems(status) {
      let items = []
      if (status == "active") {
        items = [
          {
            name: 'Terminate',
            value: 'terminate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          }
        ]
      }
      return items;
    },
    getReadinessCatalogsRoleItem(item) {
      const activateItem = {
        name: 'Activate',
        value: 'activate_role',
        icon: 'icons/dropdown/activate.svg',
        order: 1
      }
      const reActivateItem = {
        name: 'Re-activate',
        value: 're_activate_role',
        icon: 'icons/dropdown/activate.svg',
        order: 1
      }
      const retireItem = {
        name: 'Retire',
        value: 'retired_role',
        icon: 'icons/dropdown/activate.svg',
        order: 1
      }
      const attachResponsibilityItem = {
        name: 'Attach Responsibility',
        value: 'attach_responsibility_role',
        icon: 'icons/dropdown/attach.svg',
        order: 2
      }
      const renameItem = {
        name: 'Rename',
        value: 'rename_role',
        icon: 'icons/dropdown/rename.svg',
        order: 3
      }
      // ER-12129: restored Delete for Draft rows only (reverses ER-11584's removal).
      const deleteItem = {
        name: 'Delete',
        value: 'delete_role',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 4
      }
      const deActivateItem = {
        name: 'De-Activate',
        value: 'de_activate_role',
        icon: 'icons/dropdown/deactive.png',
        order: 1
      }
      const archiveItem = {
        name: 'Archive',
        value: 'archive_action',
        icon: 'icons/dropdown/archive.svg',
        order: 5
      }
      const unArchiveItem = {
        name: 'Unarchive',
        value: 'unarchive_action',
        icon: 'icons/dropdown/unarchive.svg',
        order: 5
      }
      // const detachItem = {
      //   name: 'Detach from Position',
      //   value: 'detach_role',
      //   icon: 'icons/dropdown/detach.svg',
      //   order: 1
      // }
      const roleItems = [];
      if (item?.status && item?.status.toLowerCase() == "draft") {
        roleItems.push(activateItem);
        if (item?.info?.attachments?.length > 0) {
          // roleItems.push(detachItem);
          roleItems.push(attachResponsibilityItem);
        } else {
          roleItems.push(attachResponsibilityItem);
          // roleItems.push(detachItem);
        }
      }

      if (item?.status && item?.status.toLowerCase() == "active") {
        roleItems.push(retireItem);
        // roleItems.push(deActivateItem);  // hide for ticket ER-3750
        // roleItems.push(detachItem);
        roleItems.push(attachResponsibilityItem);
      }

      if (item?.status && item?.status.toLowerCase() == "retired" && item?.archived == false) {
        roleItems.push(reActivateItem);
        roleItems.push(archiveItem);
      }
      if (item?.status && item?.status.toLowerCase() == "retired" && item?.archived == true) {
        roleItems.push(unArchiveItem);
      }

      if (item?.status && item?.status.toLowerCase() == "inactive") {
        roleItems.push(reActivateItem);
      }
      // ER-12129: Rename applies to all statuses, including Archived (Gherkin scenario 4).
      roleItems.push(renameItem);
      // ER-12129: restored Delete for Draft rows only (reverses ER-11584's removal).
      if (item?.status && item?.status.toLowerCase() === "draft") {
        roleItems.push(deleteItem);
      }
      return roleItems
    },
    getReadinessCatalogsRessponsibilitiesItem(item) {
      const responsibilitiesItems = []
      if (!item) return responsibilitiesItems
      const activateItem = {
        name: 'Activate',
        value: 'activate_responsibility',
        icon: 'icons/dropdown/activate.svg',
        order: 1
      }
      const deActivateItem = {
        name: 'De-activate',
        value: 'de_activate_responsibility',
        icon: 'icons/dropdown/deactive.png',
        order: 1
      }
      const reActivateItem = {
        name: 'Re-activate',
        value: 're_activate_responsibility',
        icon: 'icons/dropdown/activate.svg',
        order: 1
      }
      const retireItem = {
        name: 'Retire',
        value: 'retire_responsibility',
        icon: 'icons/dropdown/activate.svg',
        order: 2
      }
      const attachKnowledgeItem = {
        name: 'Attach Knowledge',
        value: 'attach_knowledge',
        icon: 'icons/dropdown/attach.svg',
        order: 3
      }
      const renameItem = {
        name: 'Rename',
        value: 'rename_responsibility',
        icon: 'icons/dropdown/rename.svg',
        order: 4
      }
      // ER-12129: restored Delete for Draft rows only (reverses ER-11584's removal).
      const deleteItem = {
        name: 'Delete',
        value: 'delete_responsibility',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 5
      }
      const archiveItem = {
        name: 'Archive',
        value: 'archive_action',
        icon: 'icons/dropdown/archive.svg',
        order: 5
      }
      const unArchiveItem = {
        name: 'Unarchive',
        value: 'unarchive_action',
        icon: 'icons/dropdown/unarchive.svg',
        order: 5
      }
      // const detachResponsibilityItem = {
      //   name: 'Detach from Role',
      //   value: 'detach_responsibility',
      //   icon: 'icons/dropdown/detach.svg',
      //   order: 2
      // }
      if (item.status && item.status.toLowerCase() == "draft") {
        responsibilitiesItems.push(activateItem);
        // responsibilitiesItems.push(detachResponsibilityItem);
      } else if (item.status && item.status.toLowerCase() == "active") {
        responsibilitiesItems.push(retireItem);
        // responsibilitiesItems.push(detachResponsibilityItem);
        // responsibilitiesItems.push(deActivateItem); // hide for ticket ER-3750
      } else if (item?.status && item?.status.toLowerCase() == "retired") {
        responsibilitiesItems.push(reActivateItem);
        responsibilitiesItems.push(archiveItem);
      } else if (item?.status && item?.status.toLowerCase() == "archived") {
        responsibilitiesItems.push(unArchiveItem);
      } else if (item?.status && item?.status.toLowerCase() == "inactive") {
        responsibilitiesItems.push(reActivateItem);
      }
      // responsibilitiesItems.push(attachKnowledgeItem); hide for now
      // ER-12129: Rename applies to all statuses, including Archived.
      responsibilitiesItems.push(renameItem);
      // ER-12129: restored Delete for Draft rows only (reverses ER-11584's removal).
      if (item?.status && item?.status.toLowerCase() === "draft") {
        responsibilitiesItems.push(deleteItem);
      }

      return responsibilitiesItems;
    },
    getAdminUsersItems(item, currentUser = null) {
      if (!currentUser) return
      const resendInviteItem = {
        name: 'Resend Invite',
        value: 'resent_invite_action',
        icon: 'icons/dropdown/resend.svg',
        order: 1
      };
      const cancelInviteItem = {
        name: 'Cancel Invite',
        value: 'cancel_invite_action',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 2,
      };
      const renameItem = {
        name: 'Rename',
        value: 'rename_action',
        icon: 'icons/dropdown/rename.svg',
        order: 3,
      };
      const closeItem = {
        name: 'Close',
        value: 'close_action',
        icon: 'icons/dropdown/activate.svg',
        negative: true,
        order: 4,
      };
      const unCloseItem = {
        name: 'Un-Close',
        value: 'unclose_action',
        icon: 'icons/dropdown/activate.svg',
        order: 5,
      };
      const blockItem = {
        name: 'Block',
        value: 'block_action',
        icon: 'icons/dropdown/activate.svg',
        negative: true,
        order: 6,
      };
      const unBlockItem = {
        name: 'Un-Block',
        value: 'unblock_action',
        icon: 'icons/dropdown/activate.svg',
        order: 7,
      };
      const deleteItem = {
        name: 'Delete',
        value: 'delete_action',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 8,
      };

      const userStatus = item.state || "draft";
      
      const isUserOwner = (currentUser) => {
        if (!currentUser?.account_permissions || !Array.isArray(currentUser.account_permissions)) {
          return false;
        }
      
        return currentUser.account_permissions.some(permission => {
          return permission?.is_owner === true;
        });
      };

      const isOwner = isUserOwner(item);

      const optionsArray = [];

      if (userStatus == "invited") {
        if (item.is_superuser) {
          optionsArray.push(renameItem);
          if (currentUser.id !== item.id) {
            optionsArray.push(deleteItem);
          }
          if (item.account_permissions && item.account_permissions.length > 0) {
            optionsArray.push(resendInviteItem);
          }
        } else {
          if (item.account_permissions && item.account_permissions.length > 0) {
            optionsArray.push(resendInviteItem);
          }
          optionsArray.push(cancelInviteItem);
          optionsArray.push(renameItem);
          optionsArray.push(deleteItem);
        }
      } else if (userStatus == "operational") {
        optionsArray.push(renameItem);
        if (currentUser.id !== item.id && !isOwner) {
          optionsArray.push(closeItem);
          optionsArray.push(blockItem);
        }
      } else if (userStatus == "closed") {
        if (currentUser.id !== item.id && !isOwner) {
          optionsArray.push(unCloseItem);
        }
      } else if (userStatus == "blocked") {
        optionsArray.push(renameItem);
        if (currentUser.id !== item.id && !isOwner) {
          optionsArray.push(unBlockItem);
        }
      }

      return optionsArray;
    },
    getAdminAccountItems(item) {
      const openItem = {
        name: 'Activate',
        value: 'admin_open_account',
        icon: 'icons/dropdown/activate.svg',
        order: 1
      }
      const deleteItem = {
        name: 'Delete',
        value: 'admin_delete_account',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 2,
      }
      const renameItem = {
        name: 'Rename',
        value: 'admin_rename_account',
        icon: 'icons/dropdown/rename.svg',
        order: 3,
      }
      const suspendItem = {
        name: 'Suspend',
        value: 'admin_suspend_account',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 4,
      }
      const changeOwnerItem = {
        name: 'Change Owner',
        value: 'admin_change_account_owner',
        icon: 'icons/dropdown/change_owner.svg',
        order: 5,
      }
      const reOpenItem = {
        name: 'Re-Open',
        value: 'admin_reopen_account',
        icon: 'icons/dropdown/activate.svg',
        order: 6,
      }
      const closeItem = {
        name: 'Close',
        value: 'admin_close_account',
        icon: 'icons/dropdown/activate.svg',
        order: 7,
      }
      const recalculateReadinessItem = {
        name: 'Recalculate readiness',
        value: 'admin_recalculate_readiness',
        icon: 'icons/dropdown/activate.svg',
        order: 8,
      }
      const cancelInviteItem = {
        name: 'Cancel Invite',
        value: 'cancel_invite_action',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 1,
      }
      const accountStatus = item?.status || "draft";
      const optionsArray = [];
      const recalculateInFlightId = arguments[1] !== undefined ? arguments[1] : null;
      const isRecalculateDisabled = recalculateInFlightId !== null && item?.id === recalculateInFlightId;
      if (accountStatus === "draft") {
        optionsArray.push(openItem);
        optionsArray.push(deleteItem);
        optionsArray.push(renameItem);
      } else if (accountStatus === "open") {
        optionsArray.push(suspendItem);
        optionsArray.push(closeItem);
        optionsArray.push(renameItem);
        optionsArray.push(changeOwnerItem);
        optionsArray.push({ ...recalculateReadinessItem, disabled: isRecalculateDisabled });
      } else if (accountStatus === "suspended") {
        optionsArray.push(reOpenItem);
        optionsArray.push(renameItem);
        optionsArray.push({ ...recalculateReadinessItem, disabled: isRecalculateDisabled });
      } else if (accountStatus === "closed") {
        optionsArray.push(reOpenItem);
        optionsArray.push(renameItem);
        optionsArray.push({ ...recalculateReadinessItem, disabled: isRecalculateDisabled });
      } else if (["pending", "pending activation", "pending-activation"].includes(accountStatus)) {
        optionsArray.push(cancelInviteItem);
        optionsArray.push(renameItem);
      }
      return optionsArray;
    },
    getSettingsUsersItems(
      item,
      currentUser = null,
      ideaMdp432AddUserWizardEnabled = false,
      ideaMdp570ResetPasswordEnabled = false,
      ideaMdp621ResetWelcomeWizardEnabled = false
    ) {
      const mdp432FlagOn = ideaMdp432AddUserWizardEnabled === true;
      const mdp570ResetPasswordOn = ideaMdp570ResetPasswordEnabled === true;
      const mdp621ResetWelcomeWizardOn = ideaMdp621ResetWelcomeWizardEnabled === true;
      const resendInviteItem = {
        name: 'Resend Invite',
        value: 'resend_invite',
        icon: 'icons/dropdown/resend.svg',
        order: 1
      }
      const cancelInviteItem = {
        name: 'Cancel Invite',
        value: 'cancel_invite_action',
        icon: 'icons/dropdown/delete.svg',
        negative: true,
        order: 2,
      }
      const changePermissionsItem = {
        name: mdp432FlagOn ? 'Change admin permission' : 'Change permissions',
        value: mdp432FlagOn ? 'change_admin_permission_action' : 'change_permissions_action',
        icon: 'icons/dropdown/give_access.svg',
        order: 3,
      }
      const renameItem = {
        name: 'Rename',
        value: 'rename_action',
        icon: 'icons/dropdown/rename.svg',
        order: 4,
      }
      const changeEmail = {
        name: 'Change Sign in email',
        value: 'change_email_action',
        icon: 'icons/dropdown/at_the_rate_sign.svg',
        order: 9,
      }
      const resetPasswordItem = {
        name: 'Reset Password',
        value: 'reset_password_action',
        icon: 'icons/dropdown/resend.svg',
        order: 10,
      }
      const resetWelcomeWizardItem = {
        name: 'Reset Welcome wizard',
        value: 'reset_welcome_wizard_action',
        icon: 'icons/dropdown/refresh-ccw-01.svg',
        order: 11,
      }
      const suspendItem = {
        name: 'Suspend',
        value: 'suspend',
        icon: 'icons/dropdown/suspend_access.svg',
        negative: true,
        order: 8,
      }
      const giveBackItem = {
        name: 'Give back access',
        value: 'give_back_access',
        icon: 'icons/dropdown/give_access.svg',
        order: 4,
      }
      const transferOwnershipItem = {
        name: 'Transfer ownership',
        value: 'transfer_ownership_action',
        icon: 'icons/dropdown/give_access.svg',
        order: 5,
      }
      const detachFromEmployeeItem = {
        name: 'Detach from Employee',
        value: 'detach_from_employee_action',
        icon: 'Detach-Red.svg',
        negative: true,
        destructive: true,
        order: 6,
      }
      /** Product: hide detach action for now; `canDetachFromEmployee` still drives other mdp432 rules. */
      const showDetachFromEmployeeMenu = false;
      const normalizeSettingsAdminPermission = (p) => {
        const s = (p ?? '')
          .toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '')
          .replace(/-/g, '');
        if (s === 'owner') return 'owner';
        if (s === 'coowner') return 'co_owner';
        if (s === 'admin' || s === 'administrator') return 'admin';
        if (s === 'none') return 'none';
        return s;
      };
      const currentLoggedInUser = JSON.parse(localStorage.getItem("accessPermission"));
      const userStatus = item?.user?.state || "invited";
      const rowPermNorm = normalizeSettingsAdminPermission(item.admin_permission);
      const isOwner = rowPermNorm === "owner";
      const isCoOwner = rowPermNorm === "co_owner";
      const isAdminRow = rowPermNorm === "admin";
      const isSuspended = item.is_suspended;
      const hasEmployee = item.has_employee;
      const canDetachFromEmployee =
        item.has_employee === true || item.employee != null;
      const hasMoreAccounts = item.account_user_has_access_count > 1;
      const isAppUser =
        item.has_readiness_access || item.has_knowledge_access ||
        item.has_performance_access || item.has_compensation_access

      const optionsArray = [];

      const sessionPerm = normalizeSettingsAdminPermission(
        currentLoggedInUser?.admin_permission
      );
      const viewingSelf = currentUser?.email === item?.user?.email;
      // MDP-634 / ER-12410: Rule 3.1 matrix. Owner may suspend/restore anyone but an Owner row
      // or their own; Co-Owner only Administrator and App User rows. Independent of app grants.
      const sessionMaySuspendRow =
        !isOwner &&
        !viewingSelf &&
        (sessionPerm === "owner" || (sessionPerm === "co_owner" && !isCoOwner));
      // Rule 4.2: restore needs employee == null OR employee ACTIVE.
      const linkedEmployeeStatus = (item.employee?.current_status ?? item.status ?? "")
        .toString()
        .toLowerCase();
      const restoreBlockedByEmployee =
        item.employee != null &&
        linkedEmployeeStatus !== "" &&
        linkedEmployeeStatus !== "active";
      const giveBackMenuItem = restoreBlockedByEmployee
        ? {
            ...giveBackItem,
            disabled: true,
            disabledReason:
              "Give back access is unavailable while the linked Employee is not active.",
          }
        : giveBackItem;
      const showChangePermissionsOnAppUserRow =
        !mdp432FlagOn || rowPermNorm !== "owner" || viewingSelf;
      const mdp432OwnerSessionOtherOwnerRow =
        mdp432FlagOn &&
        rowPermNorm === "owner" &&
        !viewingSelf &&
        sessionPerm === "owner";
      const mdp432CoOwnerRowOwnerSession =
        mdp432FlagOn &&
        rowPermNorm === "co_owner" &&
        sessionPerm === "owner";
      /**
       * Unlinked app-user row: hide Change admin permission when appropriate.
       * Administrator + not linked: Co-Owner session only (Owner may change).
       * None + not linked: Owner and Co-Owner (unchanged from prior mdp432 behavior).
       */
      const mdp432SuppressChangeAdminAppUserUnlinked =
        mdp432FlagOn &&
        !canDetachFromEmployee &&
        ((isAdminRow && sessionPerm === "co_owner") ||
          (rowPermNorm === "none" &&
            (sessionPerm === "owner" || sessionPerm === "co_owner")));
      const mdp432AdminOrNoneOwnerCoLinked =
        mdp432FlagOn &&
        (isAdminRow || rowPermNorm === "none") &&
        (sessionPerm === "owner" || sessionPerm === "co_owner") &&
        canDetachFromEmployee;

      if (isOwner && userStatus.toLowerCase() == "operational" && currentUser?.email === item?.user?.email) {
        optionsArray.push(transferOwnershipItem);
        if (showDetachFromEmployeeMenu && mdp432FlagOn && canDetachFromEmployee) {
          optionsArray.push(detachFromEmployeeItem);
        }
        if (!hasMoreAccounts) {
            optionsArray.push(renameItem);
        }
        optionsArray.push(changeEmail);
      } else if (userStatus.toLowerCase() == "operational" && currentUser?.email === item?.user?.email) {
        if (!hasMoreAccounts) {
            optionsArray.push(renameItem);
        }
        optionsArray.push(changeEmail);
      } else {
        if (isCoOwner) {
          if (userStatus.toLowerCase() == "invited") {
            optionsArray.push(resendInviteItem);
            optionsArray.push(cancelInviteItem);
            if (mdp432CoOwnerRowOwnerSession) {
              optionsArray.push(changePermissionsItem);
              if (showDetachFromEmployeeMenu && canDetachFromEmployee) {
                optionsArray.push(detachFromEmployeeItem);
              }
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
            optionsArray.push(changeEmail);
          } else if (userStatus.toLowerCase() == "operational" && !isSuspended) {
            if (sessionMaySuspendRow) {
              optionsArray.push(suspendItem);
            }
            if (mdp432CoOwnerRowOwnerSession) {
              optionsArray.push(changePermissionsItem);
              if (showDetachFromEmployeeMenu && canDetachFromEmployee) {
                optionsArray.push(detachFromEmployeeItem);
              }
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
            optionsArray.push(changeEmail);
          } else if (isSuspended) {
            if (sessionMaySuspendRow) {
              optionsArray.push(giveBackMenuItem);
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
          }
        } else if (isAppUser) {
          if (userStatus.toLowerCase() == "invited") {
            optionsArray.push(resendInviteItem);
            optionsArray.push(cancelInviteItem);
            if (mdp432OwnerSessionOtherOwnerRow) {
              optionsArray.push(transferOwnershipItem);
              if (showDetachFromEmployeeMenu && canDetachFromEmployee) {
                optionsArray.push(detachFromEmployeeItem);
              }
            }
            if (
              showChangePermissionsOnAppUserRow &&
              !mdp432SuppressChangeAdminAppUserUnlinked
            ) {
              optionsArray.push(changePermissionsItem);
            }
            if (showDetachFromEmployeeMenu && mdp432AdminOrNoneOwnerCoLinked) {
              optionsArray.push(detachFromEmployeeItem);
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
            optionsArray.push(changeEmail);
          } else if (userStatus.toLowerCase() == "operational" && !isSuspended) {
            if (mdp432OwnerSessionOtherOwnerRow) {
              optionsArray.push(transferOwnershipItem);
              if (showDetachFromEmployeeMenu && canDetachFromEmployee) {
                optionsArray.push(detachFromEmployeeItem);
              }
            }
            if (sessionMaySuspendRow) {
              optionsArray.push(suspendItem);
            }
            if (
              showChangePermissionsOnAppUserRow &&
              !mdp432SuppressChangeAdminAppUserUnlinked
            ) {
              optionsArray.push(changePermissionsItem);
            }
            if (showDetachFromEmployeeMenu && mdp432AdminOrNoneOwnerCoLinked) {
              optionsArray.push(detachFromEmployeeItem);
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
            optionsArray.push(changeEmail);
          } else if (isSuspended) {
            if (sessionMaySuspendRow) {
              optionsArray.push(giveBackMenuItem);
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
          }
        } else if (!isAppUser) {
          if (userStatus.toLowerCase() == "invited") {
            optionsArray.push(resendInviteItem);
            optionsArray.push(cancelInviteItem);
            if (mdp432OwnerSessionOtherOwnerRow) {
              optionsArray.push(transferOwnershipItem);
              if (showDetachFromEmployeeMenu && canDetachFromEmployee) {
                optionsArray.push(detachFromEmployeeItem);
              }
            }
            if (
              showChangePermissionsOnAppUserRow &&
              !mdp432SuppressChangeAdminAppUserUnlinked
            ) {
              optionsArray.push(changePermissionsItem);
            }
            if (showDetachFromEmployeeMenu && mdp432AdminOrNoneOwnerCoLinked) {
              optionsArray.push(detachFromEmployeeItem);
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
            optionsArray.push(changeEmail);
          } else if (userStatus.toLowerCase() == "operational" && !isSuspended) {
            if (mdp432OwnerSessionOtherOwnerRow) {
              optionsArray.push(transferOwnershipItem);
              if (showDetachFromEmployeeMenu && canDetachFromEmployee) {
                optionsArray.push(detachFromEmployeeItem);
              }
            }
            if (sessionMaySuspendRow) {
              optionsArray.push(suspendItem);
            }
            if (
              showChangePermissionsOnAppUserRow &&
              !mdp432SuppressChangeAdminAppUserUnlinked
            ) {
              optionsArray.push(changePermissionsItem);
            }
            if (showDetachFromEmployeeMenu && mdp432AdminOrNoneOwnerCoLinked) {
              optionsArray.push(detachFromEmployeeItem);
            }
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
            optionsArray.push(changeEmail);
          } else if (isSuspended && sessionMaySuspendRow) {
            optionsArray.push(giveBackMenuItem);
            if (!hasEmployee || !hasMoreAccounts) {
            optionsArray.push(renameItem);
            }
          }
        }
      }
      // MDP-570 / ER-10831: Owner/Co-Owner-initiated password reset (Rule 17.3).
      // Available to Owner/Co-Owner sessions on any user row, including the
      // actor's own row and any other Owner/Co-Owner (no hierarchy restriction).
      if (
        mdp570ResetPasswordOn &&
        (sessionPerm === "owner" || sessionPerm === "co_owner")
      ) {
        optionsArray.push(resetPasswordItem);
      }
      // MDP-621 / ER-12250: Owner/Co-Owner-initiated Welcome wizard reset.
      // Any active (operational, not suspended) user row, including the actor's own.
      // Placed directly after the change-permission row when that row is shown.
      if (
        mdp621ResetWelcomeWizardOn &&
        (sessionPerm === "owner" || sessionPerm === "co_owner") &&
        userStatus.toLowerCase() == "operational" &&
        !isSuspended
      ) {
        const changePermissionsIndex = optionsArray.indexOf(changePermissionsItem);
        if (changePermissionsIndex >= 0) {
          optionsArray.splice(changePermissionsIndex + 1, 0, resetWelcomeWizardItem);
        } else {
          optionsArray.push(resetWelcomeWizardItem);
        }
      }
      return optionsArray;
    },
    getScorecardDropdownItems(status) {
      let items = []
      if (status == "draft") {
        items = [
          {
            name: 'Activate',
            value: 'activate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Delete',
            value: 'delete_action',
            icon: 'icons/dropdown/delete.svg',
            negative: true,
            order: 2,
          },
          {
            name: 'Rename',
            value: 'rename_action',
            icon: 'icons/dropdown/rename.svg',
            order: 3
          },
        ]
      } else if (status == "active") {
        items = [
          {
            name: 'Retire',
            value: 'retire_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Rename',
            value: 'rename_action',
            icon: 'icons/dropdown/rename.svg',
            order: 2
          },
        ]
      } else if (status == "retired") {
        items = [
          {
            name: 'Re-Activate',
            value: 'reactivate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Rename',
            value: 'rename_action',
            icon: 'icons/dropdown/rename.svg',
            order: 2
          },
          {
            name: 'Archive',
            value: 'archive_action',
            icon: 'icons/dropdown/archive.svg',
            order: 3
          },
        ]
      } else if (status == "archived") {
        items = [
          {
            name: 'Unarchive',
            value: 'unarchive_action',
            icon: 'icons/dropdown/unarchive.svg',
            order: 1
          },
        ]
      }
      return items;
    },
    getPeriodsDropdownItems(status) {
      let items = []
      if (status == "draft") {
        items = [
          {
            name: 'Open',
            value: 'open_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Delete',
            value: 'delete_action',
            icon: 'icons/dropdown/delete.svg',
            negative: true,
            order: 2,
          }
        ]
      } else if (status == "open") {
        items = [
          {
            name: 'Close',
            value: 'close_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          },
          {
            name: 'Abandon',
            value: 'abandon_action',
            icon: 'icons/dropdown/activate.svg',
            order: 2
          },
        ]
      } else if (status == "closed") {
        items = [
          {
            name: 'Re-Activate',
            value: 'reactivate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          }
        ]
      } else if (status == "abandoned") {
        items = [
          {
            name: 'Re-Activate',
            value: 'reactivate_action',
            icon: 'icons/dropdown/activate.svg',
            order: 1
          }
        ]
      }
      return items;
    },
  }
};
